import styled from 'styled-components';
import { Table } from 'components/Base/Table';
import { TTacticTask } from './TacticTable.types';

export const StyledTacticTable = styled(Table)<{ dataSource?: TTacticTask[] }>`
  .ant-table-container
    .ant-table-thead
    > tr
    > td.ant-table-row-expand-icon-cell {
    background: ${({ theme }) => theme.colorWhitePrimary} !important;
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    border-start-start-radius: 0 !important;
  }
  .ant-table-expanded-row {
    .ant-table-cell {
      padding: 0 !important;
    }
  }

  #icon-chevron-down {
    width: 24px;
    height: 24px;
  }
`;
